/* ============================================================
   AAR Jewels - live search for the custom header dropdown.
   Adds: live product/collection/suggestion results as you type
   (Shopify Predictive Search API) + recent searches.
   Enhancement only; the native form submit still works.
   ============================================================ */
(function () {
  var KEY = 'aar-recent-searches';
  var MAX = 6;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }
  function addRecent(q) {
    q = (q || '').trim();
    if (!q) return;
    var a = read().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    a.unshift(q);
    write(a);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function initDropdown(dropdown) {
    if (dropdown.dataset.aarSearchInit === '1') return;
    dropdown.dataset.aarSearchInit = '1';

    var input = dropdown.querySelector('.aar-search-input');
    var form = dropdown.querySelector('.aar-search-form');
    var results = dropdown.querySelector('[data-aar-results]');
    var recent = dropdown.querySelector('[data-aar-hrecent]');
    var staticSections = dropdown.querySelectorAll('.aar-search-section');
    var symbol = (results && results.getAttribute('data-currency')) || '';
    if (!input || !results) return;

    function toggleStatic(show) {
      staticSections.forEach(function (s) { s.style.display = show ? '' : 'none'; });
      if (recent) recent.style.display = show ? '' : 'none';
    }

    function renderRecent() {
      if (!recent) return;
      var a = read();
      if (!a.length) { recent.hidden = true; recent.innerHTML = ''; return; }
      recent.hidden = false;
      recent.innerHTML =
        '<div class="aar-search-section__title">Recent searches' +
        '<button type="button" class="aar-recent-clear" data-aar-hclear>Clear</button></div>' +
        '<div class="aar-recent-chips">' +
        a.map(function (q) {
          return '<a class="aar-recent-chip" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(q) + '</a>';
        }).join('') +
        '</div>';
    }

    function price(p) {
      if (p == null) return '';
      if (typeof p === 'number') return symbol + (p / 100).toFixed(2);
      return symbol + p;
    }

    function renderResults(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], collections = r.collections || [], queries = r.queries || [];
      var html = '';

      if (queries.length) {
        html += '<div class="aar-search-section"><div class="aar-search-section__title">Suggestions</div><div class="aar-recent-chips">' +
          queries.slice(0, 5).map(function (x) {
            return '<a class="aar-recent-chip" href="' + esc(x.url) + '">' + esc(x.text) + '</a>';
          }).join('') + '</div></div>';
      }
      if (products.length) {
        html += '<div class="aar-search-section"><div class="aar-search-section__title">Products</div><div class="aar-search-products">' +
          products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<a class="aar-search-product" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(sized(img, 96)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="aar-search-product__ph"></span>') +
              '<span class="aar-search-product__info"><span class="aar-search-product__title">' + esc(p.title) + '</span>' +
              '<span class="aar-search-product__price">' + esc(price(p.price)) + '</span></span></a>';
          }).join('') + '</div></div>';
      }
      if (collections.length) {
        html += '<div class="aar-search-section"><div class="aar-search-section__title">Collections</div><div class="aar-search-list">' +
          collections.map(function (c) {
            return '<a class="aar-search-item" href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span></a>';
          }).join('') + '</div></div>';
      }
      if (!html) {
        html = '<div class="aar-search-empty">No matches for &ldquo;' + esc(q) + '&rdquo;. Press Enter to search everything.</div>';
      }
      results.innerHTML = html;
      results.hidden = false;
      toggleStatic(false);
    }

    var controller = null, timer = null;
    function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal })
        .then(function (res) { return res.json(); })
        .then(function (data) { renderResults(data, q); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        toggleStatic(true);
        return;
      }
      timer = setTimeout(function () { run(q); }, 200);
    });

    if (form) form.addEventListener('submit', function () { addRecent(input.value); });

    dropdown.addEventListener('click', function (e) {
      var clear = e.target.closest && e.target.closest('[data-aar-hclear]');
      if (clear) { e.preventDefault(); write([]); renderRecent(); }
      var prod = e.target.closest && e.target.closest('.aar-search-product, .aar-recent-chip');
      if (prod) addRecent(input.value);
    });

    renderRecent();
  }

  function init() {
    // Save the query when landing on a /search results page.
    if (location.pathname.indexOf('/search') !== -1) {
      try { addRecent(new URLSearchParams(location.search).get('q')); } catch (e) {}
    }
    document.querySelectorAll('.aar-search-dropdown').forEach(initDropdown);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('.aar-search-dropdown') : []).forEach(initDropdown);
  });
})();
